module.exports = __webpack_public_path__ + "img/erroeicon.f6924090.svg";